<template>
  <div class="partner-registration">
    <AuthBody title="Регистрация">
      <form v-if="!completed"
        @submit.prevent="handleSubmit" class="partner-registration__form">
        <section class="group">
          <label for="email" class="partner-registration__label">E-mail организации</label>
          <input
            id="email"
            type="email"
            v-model="email"
            class="form-control--flat"
            :readonly="loading"
            required/>
        </section>
        <section class="group">
          <label for="promo-code" class="partner-registration__label">Промо код</label>
          <input
            id="promo-code"
            type="text"
            v-model="promoCode"
            class="form-control--flat"
            :readonly="loading"/>
        </section>
        <section>
          <p>
            На указанный вами e-mail будет отправлено письмо с ссылкой на завершение регистрации.
          </p>
        </section>
        <section class="agreement">
          <PolicyAgreement
            v-model="agree"
            linkClass="link"/>
        </section>
        <section class="btn-group">
          <button :disabled="!agree" class="button btn-group__submit-btn">
            Зарегистрироваться
            <SpinnerRing v-if="loading" color="#fff" class="btn-group__loader " />
          </button>
        </section>
      </form>

      <div v-else class="partner-registration__notification">
        <section>
          <p>
            На указанный вами e-mail <strong>{{email}}</strong>
            отправлено письмо с ссылкой на завершение регистрации.
          </p>
        </section>
        <section v-if="emailProviderUrl" class="btn-group">
          <button class="button" @click="checkEmail">
            Проверить почту
          </button>
        </section>
      </div>
    </AuthBody>
  </div>
</template>

<script>
import AuthBody from '@/views/Authorize/components/AuthBody.vue';
import PolicyAgreement from '@/components/PolicyAgreement/PolicyAgreement.vue';
import SpinnerRing from '@/components/Spinner/SpinnerRing.vue';
import getEmailProviderUrl from '@/services/email-provider';
import { signUp } from '@/api/auth';


export default {
  components: { PolicyAgreement, SpinnerRing, AuthBody },

  data() {
    return {
      agree: false,
      completed: false,
      loading: false,

      email: undefined,
      promoCode: undefined,
    };
  },

  methods: {
    async handleSubmit() {
      if (!this.agree || this.loading) return;
      this.loading = true;

      try {
        await signUp(this.email, this.promoCode);
        this.completed = true;
      } catch (error) {
        this.completed = false;
      }

      this.loading = false;
    },

    checkEmail() {
      if (this.emailProviderUrl) {
        window.open(this.emailProviderUrl, '_blank');
      }
    },
  },

  computed: {
    emailProviderUrl() {
      if (!this.completed) {
        return undefined;
      }

      return getEmailProviderUrl(this.email);
    },
  },
};
</script>

<style lang="scss">
.partner-registration {
  &__form {
    section {
      &.group {
        margin-bottom: 16px;
      }

      &.agreement {
        & > .checkbox__label {
          color: white;
        }
      }

      &.btn-group {
        margin: 2.5rem 0;
      }
    }
  }

  &__notification {
    p {
      margin-bottom: 44px;
      text-align: center;
    }

    button {
      padding: 14px 68px;
      font-size: 18px;
    }
  }

  &__label {
    color: #fff;
    text-align: center;
    font-size: 18px;

    &.checkbox {
      text-align: left;
    }
  }
}
</style>
